import { render } from "./liveViewOfReports.vue?vue&type=template&id=01a85e0c"
import script from "./liveViewOfReports.vue?vue&type=script&lang=js"
export * from "./liveViewOfReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__